import React from 'react'
import { useQuery } from 'react-query';
import { getPaymentByReceiptNo } from '../../../api/apiServices'
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

function OtherPayments() {
    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/home";

    const {
        data: memDashboard
    } = useQuery(['memDashboard', params.id], () => getPaymentByReceiptNo(params.id));

    let otherPaymentData = memDashboard?.otherPaymentDetails
    let totalOtherPayments = 0;

    {
        // Total Other Payments
        otherPaymentData?.map(paymtData => {
            totalOtherPayments += paymtData.payment_amount
        })
    }

    const handleCancel = () => {
        navigate(from, { replace: true });
    }


    const othPaymtDetails = (
        <>
            <legend>Other Payment Transactions</legend>
            <div className="table-responsive lg">
                <table className="table table-borderless table-hover table-striped">
                    <thead>
                        <tr>
                            <th style={{ textAlign: "center" }}>Year</th>
                            <th style={{ textAlign: "center" }}>Payment Date</th>
                            <th style={{}}>Receipt Number</th>
                            <th style={{}}>Payment Type</th>
                            <th style={{}}>Description</th>
                            <th style={{ textAlign: "right" }}>Amount (GHS)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {otherPaymentData?.map((payment, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: "center" }}>{payment.year}</td>
                                <td style={{ textAlign: "center" }}>{format(new Date(payment.payment_date), dateFormat)}</td>
                                <td style={{}}>{payment.receipt_number}</td>
                                <td style={{ textTransform: "uppercase" }}>{payment.payment_type}</td>
                                <td>{payment.description}</td>
                                <td style={{ textAlign: "right" }}>{payment.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tbody>
                        <tr>
                            <td colSpan="6"></td>
                        </tr>
                        <tr>
                            <td colSpan="5" className="border-bottom" style={{ width: "55%", textAlign: "left", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                TOTAL OTHER PAYMENTS
                            </td>
                            {totalOtherPayments < 0 ? (
                                <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                    ({(totalOtherPayments * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                            ) : (
                                <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                    {totalOtherPayments.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                            )}
                        </tr>
                        <tr>
                            <td colSpan="7" style={{ width: "95%", borderBottom: "5px" }}></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="panel-footer">
                <div className="form-group row">
                    <div className="col-sm-2">
                        <button className="btn btn-danger" onClick={handleCancel}>Cancel</button>
                    </div>
                </div>
            </div>
        </>
    )

    return (
        <><section className="content-header">
            <h1>Other Payment Details</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Other Payments</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {othPaymtDetails}
                            </div>
                        </div>
                    </div>
                    <div className="box-footer"></div>
                </div >
            </section >
        </>
    );
}

export default OtherPayments